export default [
  {
    id: 201000000,
    value: '小说阅读高转化',
    children: [
      {
        id: 201001000,
        value: '免费小说',
        children: [],
        parentId: 201000000
      },
      {
        id: 201002000,
        value: '付费小说',
        children: [],
        parentId: 201000000
      },
      {
        id: 201003000,
        value: '通用小说',
        children: [],
        parentId: 201000000
      }
    ],
    parentId: -1
  },
  {
    id: 202000000,
    value: '汽车类高转化',
    children: [],
    parentId: -1
  },
  {
    id: 203000000,
    value: '直播类高转化',
    children: [
      {
        id: 203001000,
        value: '社交直播',
        children: [],
        parentId: 203000000
      },
      {
        id: 203002000,
        value: '游戏直播',
        children: [],
        parentId: 203000000
      }
    ],
    parentId: -1
  },
  {
    id: 204000000,
    value: '出行旅游高转化',
    children: [],
    parentId: -1
  },
  {
    id: 205000000,
    value: '教育高转化',
    children: [
      {
        id: 205001000,
        value: '职业教育',
        children: [],
        parentId: 205000000
      },
      {
        id: 205002000,
        value: '学历教育',
        children: [],
        parentId: 205000000
      }
    ],
    parentId: -1
  },
  {
    id: 206000000,
    value: '游戏高转化',
    children: [
      {
        id: 206001000,
        value: '休闲小游戏',
        children: [],
        parentId: 206000000
      },
      {
        id: 206002000,
        value: '益智游戏',
        children: [],
        parentId: 206000000
      },
      {
        id: 206003000,
        value: '捕鱼游戏',
        children: [],
        parentId: 206000000
      },
      {
        id: 206004000,
        value: 'SLG游戏',
        children: [],
        parentId: 206000000
      },
      {
        id: 206005000,
        value: '传奇游戏',
        children: [],
        parentId: 206000000
      },
      {
        id: 206006000,
        value: '卡牌游戏',
        children: [],
        parentId: 206000000
      },
      {
        id: 206007000,
        value: '网赚游戏',
        children: [],
        parentId: 206000000
      },
      {
        id: 206008000,
        value: '麻将游戏',
        children: [],
        parentId: 206000000
      }
    ],
    parentId: -1
  },
  {
    id: 207000000,
    value: '婚恋交友高转化',
    children: [],
    parentId: -1
  },
  {
    id: 208000000,
    value: '美容保健高转化',
    children: [
      {
        id: 208001000,
        value: '美容护肤',
        children: [],
        parentId: 208000000
      },
      {
        id: 208002000,
        value: '口腔护理',
        children: [],
        parentId: 208000000
      },
      {
        id: 208003000,
        value: '植发护发',
        children: [],
        parentId: 208000000
      },
      {
        id: 208004000,
        value: '运动健身',
        children: [],
        parentId: 208000000
      }
    ],
    parentId: -1
  },
  {
    id: 209000000,
    value: '房产家居高转化',
    children: [
      {
        id: 209001000,
        value: '房屋租赁',
        children: [],
        parentId: 209000000
      },
      {
        id: 209002000,
        value: '房屋买卖',
        children: [],
        parentId: 209000000
      },
      {
        id: 209003000,
        value: '家装设计',
        children: [],
        parentId: 209000000
      }
    ],
    parentId: -1
  },
  {
    id: 210000000,
    value: '新闻资讯高转化',
    children: [
      {
        id: 210001000,
        value: '娱乐八卦',
        children: [],
        parentId: 210000000
      },
      {
        id: 210002000,
        value: '军政时事',
        children: [],
        parentId: 210000000
      },
      {
        id: 210003000,
        value: '商务经济',
        children: [],
        parentId: 210000000
      },
      {
        id: 210004000,
        value: '文体艺术',
        children: [],
        parentId: 210000000
      },
      {
        id: 210005000,
        value: '生活服务',
        children: [],
        parentId: 210000000
      }
    ],
    parentId: -1
  },
  {
    id: 211000000,
    value: '软件网服高转化',
    children: [
      {
        id: 211001000,
        value: '影音播放',
        children: [],
        parentId: 211000000
      },
      {
        id: 211002000,
        value: '演出票务',
        children: [],
        parentId: 211000000
      },
      {
        id: 211003000,
        value: '餐饮美食',
        children: [],
        parentId: 211000000
      },
      {
        id: 211004000,
        value: '摄影美图',
        children: [],
        parentId: 211000000
      },
      {
        id: 211005000,
        value: '办公商务',
        children: [],
        parentId: 211000000
      }
    ],
    parentId: -1
  },
  {
    id: 212000000,
    value: '本地生活高转化',
    children: [
      {
        id: 212001000,
        value: '通讯互联',
        children: [],
        parentId: 212000000
      },
      {
        id: 212002000,
        value: '天气出行',
        children: [],
        parentId: 212000000
      },
      {
        id: 212003000,
        value: '粮油生鲜',
        children: [],
        parentId: 212000000
      },
      {
        id: 212004000,
        value: '母婴产品',
        children: [],
        parentId: 212000000
      },
      {
        id: 212005000,
        value: '服装鞋帽',
        children: [],
        parentId: 212000000
      },
      {
        id: 212006000,
        value: '二手买卖',
        children: [],
        parentId: 212000000
      }
    ],
    parentId: -1
  },
  {
    id: 213000000,
    value: '商务服务高转化',
    children: [
      {
        id: 213001000,
        value: '个体创业',
        children: [],
        parentId: 213000000
      },
      {
        id: 213002000,
        value: '拍卖服务',
        children: [],
        parentId: 213000000
      },
      {
        id: 213003000,
        value: 'IT服务',
        children: [],
        parentId: 213000000
      },
      {
        id: 213004000,
        value: '商务咨询',
        children: [],
        parentId: 213000000
      },
      {
        id: 213005000,
        value: '物流货运',
        children: [],
        parentId: 213000000
      },
      {
        id: 213006000,
        value: '招商加盟',
        children: [],
        parentId: 213000000
      },
      {
        id: 213007000,
        value: '求职招聘',
        children: [],
        parentId: 213000000
      }
    ],
    parentId: -1
  },
  {
    id: 214000000,
    value: '家电家政高转化',
    children: [
      {
        id: 214001000,
        value: '手机清理',
        children: [],
        parentId: 214000000
      },
      {
        id: 214002000,
        value: '游戏设备',
        children: [],
        parentId: 214000000
      },
      {
        id: 214003000,
        value: '家电数码',
        children: [],
        parentId: 214000000
      },
      {
        id: 214004000,
        value: '家政维修',
        children: [],
        parentId: 214000000
      },
      {
        id: 214005000,
        value: '电脑维修',
        children: [],
        parentId: 214000000
      }
    ],
    parentId: -1
  },
  {
    id: 215000000,
    value: '运动户外高转化',
    children: [
      {
        id: 215001000,
        value: '室内训练',
        children: [],
        parentId: 215000000
      },
      {
        id: 215002000,
        value: '运动装备',
        children: [],
        parentId: 215000000
      },
      {
        id: 215003000,
        value: '垂钓用品',
        children: [],
        parentId: 215000000
      },
      {
        id: 215004000,
        value: '游泳骑行',
        children: [],
        parentId: 215000000
      }
    ],
    parentId: -1
  },
  {
    id: 216000000,
    value: '投资理财高转化',
    children: [
      {
        id: 216001000,
        value: '理财培训',
        children: [],
        parentId: 216000000
      },
      {
        id: 216002000,
        value: '金融投资',
        children: [],
        parentId: 216000000
      }
    ],
    parentId: -1
  },
  {
    id: 217000000,
    value: '宠物生活高转化',
    children: [
      {
        id: 217001000,
        value: '宠物洗护',
        children: [],
        parentId: 217000000
      },
      {
        id: 217002000,
        value: '宠物零食',
        children: [],
        parentId: 217000000
      },
      {
        id: 217003000,
        value: '猫狗领养',
        children: [],
        parentId: 217000000
      }
    ],
    parentId: -1
  },
  {
    id: 218000000,
    value: '工具类软件高次留',
    children: [
      {
        id: 218001000,
        value: '网赚工具',
        children: [],
        parentId: 218000000
      },
      {
        id: 218002000,
        value: '清理工具',
        children: [],
        parentId: 218000000
      },
      {
        id: 218003000,
        value: '社交软件',
        children: [],
        parentId: 218000000
      },
      {
        id: 218004000,
        value: '修图工具',
        children: [],
        parentId: 218000000
      },
      {
        id: 218005000,
        value: '天气工具',
        children: [],
        parentId: 218000000
      }
    ],
    parentId: -1
  }
]
